// src/i18n.tsx
import React from "react";
import { IntlProvider } from "react-intl";
import { LOCALES } from "../app/constant/Locales";
import { useLanguage } from "../utils/LanguageHookHelper";
import enMessages from "./messages/en.json";
import myMessages from "./messages/my.json";
import zhMessages from "./messages/zh.json";

const messages: { [key: string]: any } = {
  [LOCALES.ENGLISH]: enMessages,
  [LOCALES.CHINESE]: zhMessages,
  [LOCALES.MALAY]: myMessages,
};

const I18nProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const locale = useLanguage();

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {children}
    </IntlProvider>
  );
};

export default I18nProvider;
